import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Box, Button,useMediaQuery } from '@mui/material';


const ProductCard = ({ data, type, history, showPrice = true }) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [loadedImages, setLoadedImages] = useState({});
  const [warmedHoverImages, setWarmedHoverImages] = useState({});
  const cardWidth = isMobile ? 165 : 270;
  const imageHeight = isMobile ? 140 : 230;

  const formatUnitPrice = (rawText) => {
    const text = String(rawText || "").trim().replace(/,+$/, "");
    if (!text) {
      return "";
    }
    const numericText = text.replace(/MMK/i, "").replace(/,/g, "").trim();
    const numericValue = Number(numericText);
    if (!Number.isNaN(numericValue)) {
      return `${numericValue.toLocaleString()} MMK`;
    }
    return text.includes("MMK") ? text : `${text} MMK`;
  };

  const renderPrice = (priceValue) => {
    if (typeof priceValue === "string" && priceValue.includes("-")) {
      const entries = priceValue
        .split(/,\s*(?=\D)/)
        .map((entry) => entry.trim())
        .filter(Boolean);
      const parsedEntries = entries
        .map((entry) => {
          const [rawTitle, priceText = ""] = entry
            .split("-")
            .map((part) => part.trim());
          const titleMatch = String(rawTitle || "").match(/^(.*)\[(.*)\]$/);
          const sizeLabel = titleMatch
            ? String(titleMatch[2] || "").trim()
            : "";
          const title = titleMatch
            ? sizeLabel
            : String(rawTitle || "").trim();
          const numericText = String(priceText)
            .replace(/MMK/gi, "")
            .replace(/,/g, "")
            .replace(/[^\d.]/g, "")
            .trim();
          const numericValue = Number(numericText);
          return {
            key: entry,
            sizeLabel,
            numericValue,
            label: title
              ? `${title} - ${formatUnitPrice(priceText)}`
              : formatUnitPrice(priceText),
          };
        })
        .filter(Boolean);
      const sizedEntries = parsedEntries.filter((entry) => entry.sizeLabel);
      if (sizedEntries.length > 0) {
        return sizedEntries.map((entry, index) => {
          const suffix = index < sizedEntries.length - 1 ? ", " : "";
          return (
            <span key={`${entry.key}-${index}`}>
              {`${entry.sizeLabel}${suffix}`}
            </span>
          );
        });
      }
      const visibleEntries = parsedEntries.filter(
        (entry) => !Number.isFinite(entry.numericValue) || entry.numericValue > 0
      );
      return visibleEntries.map((entry, index) => {
        const suffix = index < visibleEntries.length - 1 ? "," : "";
        return (
          <span key={`${entry.key}-${index}`} style={{ display: "block" }}>
            {`${entry.label}${suffix}`}
          </span>
        );
      });
    }
    const numericValue =
      typeof priceValue === "number"
        ? priceValue
        : typeof priceValue === "string" && priceValue.trim() !== ""
        ? Number(priceValue.replace(/,/g, ""))
        : NaN;
    if (!Number.isNaN(numericValue)) {
      return `${numericValue.toLocaleString()} MMK`;
    }
    if (!priceValue) {
      return "";
    }
    const trimmed = String(priceValue).trim().replace(/,+$/, "");
    return formatUnitPrice(trimmed);
  };

  const handleRedirect = (item) => { 
    const productId = item?.productId ?? item?.product_Id ?? "";
    const pathname = productId ? `/detail/${productId}` : "/detail";
    history.push({
      pathname,
      state: { item }, // Pass the item object as part of state
    });
    window.scrollTo(0, 0);  
  };
const getImageUrl = (item,index) => {
    if (!item?.dataLst || !item.dataLst[index]) {
      return ""; // Return an empty string if dataLst or its first item is not available
    }
  
    const baseEndpoint =
      process.env.REACT_APP_RESOURCE_ENDPOINT ||
      process.env.REACT_APP_RESOURCE_ENDPOINT;
    const productId = item.dataLst[index].product_Id;
    const imageName = item.dataLst[index].image;
    const businessName = item.dataLst[index].businessName
  
    if (!baseEndpoint || !productId || !imageName) {
      return ""; // Return an empty string if any required data is missing
    }
    return `${baseEndpoint}/Upload/Ecommerce/${businessName}/${productId}/${imageName}`;
  };
  
  return (
    <>
      {data.map((item, index) => {
        const productKey =
          item?.productId ??
          item?.product_Id ??
          item?.productCode ??
          `${item?.productTitle || "product"}-${index}`;
        const primaryImageUrl = getImageUrl(item, 1) || getImageUrl(item, 0);
        const hoverImageUrl = warmedHoverImages[productKey] ? getImageUrl(item, 0) : "";
        const isLoaded = loadedImages[productKey];

        return (
        <Card
          key={productKey}
          onMouseEnter={() =>
            setWarmedHoverImages((previous) =>
              previous[productKey] ? previous : { ...previous, [productKey]: true }
            )
          }
          onFocus={() =>
            setWarmedHoverImages((previous) =>
              previous[productKey] ? previous : { ...previous, [productKey]: true }
            )
          }
          sx={{
            width: cardWidth,
            position: 'relative',
            overflow: 'hidden',
            borderRadius: isMobile ? '14px' : '18px',
            background: 'linear-gradient(180deg, #ffffff 0%, #f6f1ec 100%)',
            border: '1px solid rgba(17, 17, 17, 0.08)',
            boxShadow: '0 10px 26px rgba(17, 17, 17, 0.08)',
            transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
            '&:hover': {
              transform: 'translateY(-6px)',
              boxShadow: '0 16px 34px rgba(17, 17, 17, 0.14)',
              borderColor: 'rgba(17, 17, 17, 0.18)',
            },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              height: imageHeight,
              width: '100%',
              backgroundColor: '#fdfbf8',
              overflow: 'hidden',
              borderBottom: '1px solid rgba(17, 17, 17, 0.06)',
              '&::after': {
                content: '""',
                position: 'absolute',
                inset: 0,
                background: 'rgba(17,17,17,0.18)',
                pointerEvents: 'none',
              },
              '&:hover .hoverOverlay': { // Show overlay on hover
                opacity: 1,
              },
            }}
          >
            {!isLoaded && (
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  zIndex: 0,
                  background:
                    'linear-gradient(110deg, #f4f4f4 8%, #ffffff 18%, #f4f4f4 33%)',
                  backgroundSize: '200% 100%',
                  animation: 'productImageSkeleton 1.2s linear infinite',
                  '@keyframes productImageSkeleton': {
                    '0%': { backgroundPosition: '200% 0' },
                    '100%': { backgroundPosition: '-200% 0' },
                  },
                }}
              />
            )}
            {/* Main Image */}
            <CardMedia
              component="img"
              className="mainImage"
              key={`${productKey}-main-${primaryImageUrl}`}
              image={primaryImageUrl}
              alt={item.productTitle}
              loading={index < 3 ? "eager" : "lazy"}
              decoding="async"
              fetchPriority={index < 3 ? "high" : "low"}
              onLoad={() =>
                setLoadedImages((previous) =>
                  previous[productKey] ? previous : { ...previous, [productKey]: true }
                )
              }
              onError={() =>
                setLoadedImages((previous) =>
                  previous[productKey] ? previous : { ...previous, [productKey]: true }
                )
              }
              sx={{
                transition: 'opacity 0.3s ease',
                position: 'absolute',
                zIndex: 1,
                width:  '100%',
                height:  '100%',
                objectFit: 'contain',
                padding: isMobile ? '10px' : '16px',
                backgroundColor: 'transparent',
                boxSizing: 'border-box',
                opacity: 1,
              }}
            />
            
        
            <Box
              className="hoverOverlay"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                opacity: 0, 
                transition: 'opacity 0.3s ease',
                background: 'linear-gradient(180deg, rgba(17,17,17,0.2), rgba(17,17,17,0.75))',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                zIndex: 2,
              }}
            >
              {hoverImageUrl && (
                <CardMedia
                  component="img"
                  className="hoverImage"
                  key={`${productKey}-hover-${hoverImageUrl}`}
                  image={hoverImageUrl} 
                  alt={`${item.productTitle} hover`}
                  loading="lazy"
                  decoding="async"
                  fetchPriority="low"
                  sx={{
                    objectFit: 'contain',
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    padding: isMobile ? '10px' : '16px',
                    backgroundColor: 'transparent',
                    boxSizing: 'border-box',
                    opacity: 1,
                  }}
                />
              )}
              <Button
                variant="contained"
                sx={{
                  zIndex: 3,
                  backgroundColor: '#ffffff',
                  position: "absolute",
                  bottom: isMobile? "12px" : "18px",
                  color: '#111111',
                  textTransform: "capitalize",
                  fontWeight: "700",
                  borderRadius: "999px",
                  paddingX: isMobile ? "14px" : "18px",
                  paddingY: isMobile ? "6px" : "8px",
                  boxShadow: '0 10px 24px rgba(0,0,0,0.25)',
                  '&:hover': {
                    backgroundColor: '#f1f1f1',
                  },
                }}
                onClick={() => handleRedirect(item)}
              >
                Shop Now
              </Button>
            </Box>
          </Box>

          <CardContent
            sx={{
              backgroundColor: 'transparent',
              padding: isMobile ? '12px 12px 16px' : '16px 16px 20px',
            }}
          >
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{
                fontSize: isMobile ? "13px" : '16px',
                fontWeight: 700,
                lineHeight: 1.35,
                color: '#191919',
                fontFamily: "'Amiko', 'Anek Malayalam', 'Segoe UI', sans-serif",
              }}
            >
              {item.productTitle}
            </Typography>
            {showPrice && (
              <Typography
                variant="body2"
                sx={{
                  fontSize: isMobile ? "11px" : '14px',
                  fontWeight: 600,
                  color: '#2a2a2a',
                  lineHeight: 1.5,
                  fontFamily: "'Amiko', 'Anek Malayalam', 'Segoe UI', sans-serif",
                }}
              >
                {renderPrice(item.price)}
              </Typography>
            )}
            {item.otherData && (
              <>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  sx={{
                    fontSize: isMobile ? "13px" : '15px',
                    fontWeight: 700,
                    marginTop: '10px',
                    color: '#1a1a1a',
                    fontFamily: "'Amiko', 'Anek Malayalam', 'Segoe UI', sans-serif",
                  }}
                >
                  {item.otherData.name}
                </Typography>
                {showPrice && (
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: isMobile ? "11px" : '14px',
                      fontWeight: 600,
                      color: '#2a2a2a',
                      lineHeight: 1.5,
                      fontFamily: "'Amiko', 'Anek Malayalam', 'Segoe UI', sans-serif",
                    }}
                  >
                    {renderPrice(item.otherData.price)}
                  </Typography>
                )}
              </>
            )}
          </CardContent>
        </Card>
      )})}
    </>
  );
};

export default ProductCard;
